/**
 * Admin audit feed for worker time tracking (task 17 §3.10).
 *
 * Источник — `GET /api/admin/timesheet-audit` (см. §2.5 / репо
 * `timesheets_repo.list_timesheet_audit`). Keyset cursor — compound
 * `<iso_created_at>|<id>`, склеивается клиентом из последней строки
 * предыдущей страницы.
 */
import { api } from "./client";
import type { components } from "./types";

export type TimesheetAuditEntry = components["schemas"]["TimesheetAuditEntry"];
export type TimesheetAuditUserRef = components["schemas"]["TimesheetAuditUserRef"];
export type TimesheetAuditProjectRef = components["schemas"]["TimesheetAuditProjectRef"];
export type TimesheetAuditWorkTypeRef = components["schemas"]["TimesheetAuditWorkTypeRef"];

export interface ListTimesheetAuditParams {
  date_from?: string; // YYYY-MM-DD
  date_to?: string; // YYYY-MM-DD
  user_id?: number;
  project_id?: number;
  work_type_id?: number;
  include_deleted?: boolean;
  needs_attention?: boolean;
  admin_backfill_only?: boolean;
  cursor?: string;
  limit?: number;
}

export function listTimesheetAudit(
  params: ListTimesheetAuditParams = {},
): Promise<TimesheetAuditEntry[]> {
  const qs = new URLSearchParams();
  if (params.date_from) qs.set("date_from", params.date_from);
  if (params.date_to) qs.set("date_to", params.date_to);
  if (params.user_id !== undefined) qs.set("user_id", String(params.user_id));
  if (params.project_id !== undefined) qs.set("project_id", String(params.project_id));
  if (params.work_type_id !== undefined) qs.set("work_type_id", String(params.work_type_id));
  if (params.include_deleted !== undefined) {
    qs.set("include_deleted", params.include_deleted ? "true" : "false");
  }
  if (params.needs_attention) qs.set("needs_attention", "true");
  if (params.admin_backfill_only) qs.set("admin_backfill_only", "true");
  if (params.cursor) qs.set("cursor", params.cursor);
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  const tail = qs.toString();
  return api.get<TimesheetAuditEntry[]>(`/admin/timesheet-audit${tail ? `?${tail}` : ""}`);
}

/** Cursor — compound `(created_at, id)` из последней строки страницы. */
export function cursorFromEntry(entry: TimesheetAuditEntry): string {
  return `${entry.created_at}|${entry.id}`;
}

export type AdminTimesheetWorker = components["schemas"]["AdminTimesheetWorker"];

/** Список рабочих для admin-picker'а. См. `admin_timesheet_backfill.list_workers_for_backfill`. */
export function listTimesheetWorkers(): Promise<AdminTimesheetWorker[]> {
  return api.get<AdminTimesheetWorker[]>("/admin/timesheet/users");
}
